<template>
  <div class="dicAddBox">
    <Form ref="addForm" :label-width="120" :model="formCustom" :rules="addRules" inline>
      <Form-item label="字典名称：" prop="dicId">
        <Select v-model="formCustom.dicId" filterable style="width: 240px" @on-change="changeDicName">
          <Option v-for="item in dicList" :value="item.dicId">{{ item.dicName }}</Option>
        </Select>
      </Form-item>
      <br>
      <FormItem label="字典项文本：" prop="itemText">
        <Input v-model="formCustom.itemText" clearable placeholder="请输入" style="width: 240px"></Input>
      </FormItem>
      <br>
      <FormItem label="字典项值：" prop="itemValue">
        <Input v-model="formCustom.itemValue" clearable placeholder="请输入" style="width: 240px"></Input>
      </FormItem>
      <br>
      <Form-item label="排序：" prop="itemOrder">
        <Input v-model="formCustom.itemOrder" clearable placeholder="请输入" style="width: 240px"></Input>
      </Form-item>
      <br>
      <Form-item label="描述：" prop="description">
        <Input v-model="formCustom.description" placeholder="请输入" style="width: 380px" type="textarea"></Input>
      </Form-item>
    </Form>
    <div class="footerButton">
      <Button type="default" @click="handleBack('add')">返回</Button>
      <Button :loading="addLoading" style="margin-left: 10px" type="primary" @click="handleCommit('addForm')">
        <span v-if="!addLoading">提交</span>
        <span v-else>提交中</span>
      </Button>
    </div>
  </div>
</template>

<script>
import {dicAdd, dicList} from '@/api/authority'

export default {
  name: 'dicAdd',
  data() {
    return {
      addLoading: false,
      dicList: [], // 关联角色下拉框
      formCustom: {
        dicId: '',
        itemText: '',
        itemValue: '',
        itemOrder: '',
        description: '',
      },
      addRules: {
        dicId: [{required: true, message: '字典名称不能为空', trigger: 'change', type: 'number'}],
        itemText: [{required: true, message: '字典项文本不能为空', trigger: 'blur'}]
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    // 初始化
    init() {
      dicList().then((response) => {
        this.dicList = response.data.data
      })
    },
    changeDicName(val) {
      this.formCustom.dicId = val;
    },
    // 返回
    handleBack() {
      this.$router.push(
        {
          path: '/authority/dic',
          query: {
            current: this.$route.query.current,
            size: this.$route.query.size,
            dicCode: this.$route.query.dicCode,
            dicItemText: this.$route.query.dicItemText,
            status: this.$route.query.status
          }
        }
      )
    },
    // 提交
    handleCommit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.addLoading = true
          dicAdd({
            dicId: this.formCustom.dicId,
            itemText: this.formCustom.itemText,
            itemValue: this.formCustom.itemValue,
            itemOrder: this.formCustom.itemOrder,
            description: this.formCustom.description
          }).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
              this.addLoading = false
            } else {
              this.$Message.success(response.data.msg)
              this.addLoading = false
              this.$router.push({name: 'dic'})
            }
          }).catch(() => {
            this.addLoading = false
          })
        }
      })
    }
  }
}
</script>
